import { render, staticRenderFns } from "./InstallmentsWrapper.vue?vue&type=template&id=dbe92a44"
import script from "./InstallmentsWrapper.vue?vue&type=script&lang=js"
export * from "./InstallmentsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports